var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroll",staticClass:"t-scroll"},[_c('div',{staticClass:"t-scroll-fixed"},[_vm._t("fixed")],2),_c('div',{staticClass:"t-scroll-box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }